import React, { useCallback, useContext, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { ThemeContext } from '../../../ThemeProvider/ThemeProvider';
import { SidebarContainer } from './styles';
import { SideBarProps } from './types';
import { SideBarNodeProps } from './SideBarNode/types';

export const SideBar: React.FC<SideBarProps> = ({
  testId,
  isOpen,
  children,
  isMobile,
  onClose,
  history,
  keepOpen,
}) => {
  const { actualTheme } = useContext(ThemeContext);
  const [openNode, setOpenNode] = useState<number>(null);

  const toggleNode = useCallback(
    (index: number) => () => {
      setOpenNode((prevState: number) => {
        if (prevState === index) return null;
        return index;
      });
    },
    [],
  );

  const selectNode = useCallback(
    (index: number) => () => {
      setOpenNode((prevState: number) => {
        if (prevState === index) return null;
        return index;
      });
    },
    [],
  );

  return (
    <ThemeProvider theme={actualTheme}>
      <SidebarContainer data-testid={testId} isOpen={isOpen} isMobile={isMobile}>
        <div>
          {React.Children.map(children, (child, index) => {
            if (React.isValidElement<SideBarNodeProps>(child)) {
              return React.cloneElement(child, {
                isBarOpen: isOpen,
                opened: openNode === index,
                toggleNode: toggleNode(index),
                selectNode: selectNode(index),
                onClose,
                history,
                keepOpen,
              });
            }
            return child;
          })}
        </div>
      </SidebarContainer>
    </ThemeProvider>
  );
};

export default SideBar;
